/* oxlint-disable no-console */

import { BaseLogger } from "./BaseLogger.ts";
import { varDump } from "./formatting.ts";

export class ConsoleLogger extends BaseLogger {
  protected debugOutput(...args: readonly unknown[]): void {
    console.debug(...this.serializeArgs(args));
  }

  protected errorOutput(...args: readonly unknown[]): void {
    console.error(...this.serializeArgs(args));
  }

  protected infoOutput(...args: readonly unknown[]): void {
    console.info(...this.serializeArgs(args));
  }

  protected warnOutput(...args: readonly unknown[]): void {
    console.warn(...this.serializeArgs(args));
  }

  private serializeArgs(args: readonly unknown[]): readonly unknown[] {
    return args.map(arg => {
      if (typeof arg === "object" && arg) {
        return varDump(arg) ?? arg;
      }

      return arg;
    });
  }
}
